// extracted by mini-css-extract-plugin
export default {"freemium-banner-responsive":"Uhp3Ux","freemiumBannerResponsive":"Uhp3Ux","rtl":"unGxLv","ltr":"NnPibr","overlay":"lF_40u","link":"odPa7O","text":"rzI5_V","logo":"BIbtE1"};